module.exports = __webpack_public_path__ + "img/question.7ade9db9.svg";